import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog'; // New dialog component
import { SubtasksDialogComponent } from './PM/preventive-maintenance/schedule-task/subtasks-dialog.component';
@Component({
  selector: 'btn-cell-renderer',
  template: `
    <style>
      .edit-btn {
        color: white;
        background: #3aafe4;
        margin-right: 5px;
      }
      .delete-btn-technician {
        color: white;
        background: red;
        margin-right: 5px;
      }
      .view-btn {
        color: white;
        background: orange;
        margin-right: 5px;
      }
      .subtasks-btn {
        color: white;
        background: #4caf50; /* Green for subtasks */
        margin-right: 5px;
      }
      .technicianresponsible-btn {
        color: white;
        background: rgb(85, 57, 180); /* Green for subtasks */
        margin-right: 5px;
      }
      .rca-btn {
        color: white;
        background: rgb(206, 105, 23); /* Green for subtasks */
        margin-right: 5px;
      }
      i {
        color: white;
      }
      .btn:disabled {
        opacity: 0.5;
      }
      .btn {
        padding: 7px 10px;
        border: none;
        border-radius: 5px;
        cursor: pointer;
      }
      .d-flex {
        display: flex;
      }
    </style>
    <div class="d-flex">
      <button
        [hidden]="this.params.data.Task"
        class="view-btn btn custom-tooltip"
        style="background-color: #16cbd0; margin-right: 5px"
        [title]="t('QRCode', 'QR Code')"
        mat-icon-button
        matTooltip="QRCode"
        matTooltipPosition="right"
        (click)="onClickQRCode($event)"
      >
        <i class="fa fa-qrcode" aria-hidden="true"></i>
      </button>

      <!-- Edit Button -->
      <!-- Edit Button -->
      <button
        [hidden]="isAssigned"
        class="edit-btn btn"
        [title]="t('Edit', 'Edit')"
        mat-icon-button
        [disabled]="params.data.WOStatus === 'Close' || status == 'Done' || status == 'Close'"
        (click)="onClickEdit($event)"
      >
        <i class="fa fa-pencil-square-o"></i>
      </button>

      <!-- View Button -->
      <button
        [hidden]="isAssigned"
        class="view-btn btn"
        [title]="t('View', 'View')"
        mat-icon-button
        (click)="onClickView($event)"
      >
        <i class="fa fa-eye"></i>
      </button>

      <button
        [hidden]="!this.params.data?.Task && !this.params.data?.WOId"
        class="subtasks-btn btn custom-tooltip"
        [title]="t('SubWorkOrder', 'Sub Work Order')"
        mat-icon-button
        matTooltip="View Sub Work Order"
        matTooltipPosition="right"
        (click)="handleSubtask($event)"
      >
        <i class="fa fa-tasks" aria-hidden="true"></i>
      </button>
      <!-- <button
        [hidden]="IsWoTab && !this.params.data?.WOId"
        class="technicianresponsible-btn btn custom-tooltip"
        [title]="t('TechnicianResponsible', 'Technician Responsible')"
        mat-icon-button
        matTooltip="View TechnicianResponsible"
        matTooltipPosition="right"
        [disabled]="!disabled"
        (click)="handleTechnicianResponsible($event)"
      >
        <i class="fa fa-plus" aria-hidden="true"></i>
      </button> -->

      <button
        [hidden]="
          (IsWoTab && !this.params.data?.WOId) ||
          this.params.data?.rca ||
          this.params.data?.Status === 'Close' ||
          this.params.data?.Status === 'Complete'
        "
        class="rca-btn btn custom-tooltip"
        [title]="t('CreateRCA', 'Create RCA')"
        mat-icon-button
        matTooltip="Create RCA"
        matTooltipPosition="right"
        (click)="handleRCA($event)"
      >
        <i class="fa fa-list" aria-hidden="true"></i>
      </button>
    </div>
  `,
})
export class ActionEditDeleteViewBtnRendererTechnician
  implements ICellRendererAngularComp, OnDestroy {
  params: any;
  isAssigned: boolean = false;
  status: string = '';
  IsWoTab: boolean = false;
  disabled: boolean = false;
  constructor(private dialog: MatDialog, public translate: TranslateService) { } // Inject MatDialog

  /** "PM.<key>" from the JSON files -> flat key -> English fallback. */
  public t(key: string, fallback: string): string {
    for (const candidate of ['PM.' + key, key]) {
      const value = this.translate.instant(candidate);
      if (typeof value === 'string' && value !== candidate) {
        return value;
      }
      if (value && typeof value === 'object' && typeof value.title === 'string') {
        return value.title;
      }
    }
    return fallback;
  }


  agInit(params: any): void {
    this.params = params;
    this.isAssigned = !params?.IsAssignedToMainTask;
    this.status = params?.data.Status;
    this.IsWoTab = params?.IsWoTab;
    this.disabled = params?.disabled;
  }

  refresh(params: any): boolean {
    this.params = params;
    this.isAssigned = !params?.IsAssignedToMainTask;
    return true;
  }
  onClickEdit($event: any): void {
    if (this.params.onClickEdit instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        index: this.params.node.rowIndex,
      };
      this.params.onClickEdit(params);
    }
  }

  onClickView($event: any): void {
    if (this.params.onClickView instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        index: this.params.node.rowIndex,
      };
      this.params.onClickView(params);
    }
  }

  onClickQRCode($event: any): void {
    if (this.params.onClickQRCode instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        index: this.params.node.rowIndex,
      };
      this.params.onClickQRCode(params);
    }
  }
  handleSubtask($event: any): void {
    if (this.params?.onClickSubtask) {
      this.params.onClickSubtask(this.params.data);
    } else {
    }
  }
  handleTechnicianResponsible($event: any): void {
    if (this.params?.onClickTechnicianResponsible) {
      this.params.onClickTechnicianResponsible(this.params.data);
    } else {
    }
  }
  handleRCA($event: any): void {
    if (this.params?.onClickRCA) {
      this.params.onClickRCA(this.params.data);
    } else {
    }
  }
  onClickSubtasks($event: any): void {
    // Open the dialog with AG Grid for subtasks
    this.dialog.open(SubtasksDialogComponent, {
      width: '80%',
      height: 'auto',
      data: {
        rowData: this.params.node.data, // Pass parent row data if needed
      },
    });
  }

  ngOnDestroy(): void { }
}
